import { render, staticRenderFns } from "./SingleProjectShare.vue?vue&type=template&id=54f376b3&scoped=true"
import script from "./SingleProjectShare.vue?vue&type=script&lang=js"
export * from "./SingleProjectShare.vue?vue&type=script&lang=js"
import style0 from "./SingleProjectShare.vue?vue&type=style&index=0&id=54f376b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f376b3",
  null
  
)

export default component.exports